import Renderer from 'react-markdown';

interface MarkdownProps {
  children: string;
  className?: string;
}

function Markdown({ className, children }: MarkdownProps) {
  return <Renderer className={className}>{children}</Renderer>;
}

export default Markdown;
